import React, { useState, useEffect } from 'react';
import { FiMail } from 'react-icons/fi';
import ActionButton from './ActionButton';
import apiClient from '../../../apiClient';
import { getEmailTemplates } from '../../../api/emailTemplates';
import EmailTemplateSelector from '../Email/EmailTemplateSelector';

const MailButton = ({ email }) => {
  const [templates, setTemplates] = useState([]);
  const [showSelector, setShowSelector] = useState(false);
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    getEmailTemplates()
      .then(response => {
        if (Array.isArray(response.data)) {
          setTemplates(response.data);
        } else {
          console.error('Email templates response is not an array:', response.data);
          setTemplates([]);
        }
      })
      .catch(error => {
        console.error('Failed to fetch email templates:', error);
        setTemplates([]);
      });
  }, []);

  const sendEmail = async (template) => {
    setSending(true);
    setMessage('');
    try {
      // Call backend API to send email
      await apiClient.post('/api/emailTemplates/send', {
        to: email,
        templateId: template.id,
        variables: {} // Add any variables if needed
      });
      setMessage('Email sent successfully');
    } catch (error) {
      console.error('Failed to send email:', error);
      setMessage('Failed to send email');
    } finally {
      setSending(false);
      setShowSelector(false);
    }
  };

  const handleButtonClick = (e) => {
    e.stopPropagation();
    setShowSelector(true);
    setMessage('');
  };

  const handleTemplateSelect = (template) => {
    sendEmail(template);
  };

  const handleClose = () => {
    setShowSelector(false);
    setMessage('');
  };

  if (!email) return null;

  return (
    <>
      <ActionButton
        icon={FiMail}
        onClick={handleButtonClick}
        title="Send Email"
        className="mail-btn"
        disabled={sending}
      />
      {message && <div className="email-message">{message}</div>}
      {showSelector && (
        <EmailTemplateSelector
          templates={templates}
          onSelect={handleTemplateSelect}
          onClose={handleClose}
          disabled={sending}
        />
      )}
    </>
  );
};

export default MailButton;
